"use strict";
exports.__esModule = true;
exports.ActionTypes = void 0;
// Action Types
exports.ActionTypes = {
    UPDATE_IS_LOADING: 'UPDATE_IS_LOADING',
    SET_DISAMBIGUATION_DATA: 'SET_DISAMBIGUATION_DATA',
    UPDATE_EDITED_DISAMBIGUATION_DATA: 'UPDATE_EDITED_DISAMBIGUATION_DATA',
    UPDATE_IS_SAVE_DISABLED: 'UPDATE_IS_SAVE_DISABLED',
    UPDATE_CURRENT_LANGUAGE: 'UPDATE_CURRENT_LANGUAGE',
    SET_SUPPORTED_LANGUAGES: 'SET_SUPPORTED_LANGUAGES',
    UPDATE_CURRENT_LANGUAGE_SCRIPTS: 'UPDATE_CURRENT_LANGUAGE_SCRIPTS',
};
exports["default"] = { ActionTypes: exports.ActionTypes };
